import Layout from '@/layout'

const userManage = {
    path: '/patient/user',
    component: Layout,
    children: [
        {
            path: 'userList',
            component: () => import('@/views/patient/user/userList')
        },
        {
            path: 'userDetails',
            component: () => import('@/views/patient/user/userDetails'),
            meta: { activeMenu: '/patient/user/userList' }
        }
    ]
}

export default userManage
